import * as actionTypes from 'actions';
import moment from 'moment'; 
import { object } from 'prop-types';
  
const initV = {
 token:"",
 expiredAt:0,
};

let localData = localStorage.getItem("adminUser");
let adminUser = {};
try{
 adminUser = JSON.parse(localData);
}catch{
}


const initialState = Object.assign(initV,adminUser);
const payseverReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.LOGIN_PAYSERVER: {    
      const a =  Object.assign({},state,{token:action.token,expiredAt:action.expiredAt}) 
      localStorage.setItem("adminUser",JSON.stringify(a));
      return a;
    } 
    default: { 
      return state;
    }
  }
};

export default payseverReducer;
